import styled from 'styled-components';
import { Select } from '@/ui';
import { COLORS } from '@/theme';

export const StyledWrapper = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const StyledSelect = styled(Select)<{ $isActive: boolean }>`
  &&& {
    height: 2.85rem;
    .ant-select-selection-item {
      color: ${({ $isActive }) => ($isActive ? COLORS.GREEN : COLORS.RED)} !important;
    }
  }
`;
